module.exports = __webpack_public_path__ + "static/media/background_idiom.668f34bf.png";